import { memo } from "react";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import "./LuggagePlaceholderLoader.scss";
import IconCarryOnLuggageAvailable from "app/pages/.shared/static/icons/IconCarryOnLuggageAvailable";
import IconCheckInLuggageAvailable from "app/pages/.shared/static/icons/IconCheckInLuggageAvailable";

const LuggagePlaceholderLoader = () => {
	return (
		<div className="luggage-placeholder">
			<div className="luggage-placeholder__loader">
				<div className="luggage-placeholder__loader-icon">
					<IconCarryOnLuggageAvailable />
				</div>
				<LoaderBar />
			</div>
			<div className="luggage-placeholder__loader">
				<div className="luggage-placeholder__loader-icon">
					<IconCheckInLuggageAvailable />
				</div>
				<LoaderBar />
			</div>
		</div>
	);
};

export default memo(LuggagePlaceholderLoader);
